import styled from 'styled-components';

export const RootStyled = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.primary.onMain};
  color: ${({ theme }) => theme.colors.neutral.onContainer};
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 72px 84px;
  border-radius: 20px;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const ContentStyled = styled.div`
  width: 100%;
  max-width: 776px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  word-wrap: break-word;
  overflow-x: auto;
  gap: 24px;
`;

export const TitleStyled = styled.span`
  ${(p) => p.theme.typography.title2};
`;

export const TextStyled = styled.div`
  ${(p) => p.theme.typography.body1};

  &.content.is-article {
    padding: 0;
  }
`;

export const SubmissionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EditorContainer = styled.div`
  width: 100%;

  & div[role='textbox'] {
    height: 160px;
  }
`;

export const ActionsStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
